import React from "react";
import { Link, useBCMSContext, BCMSRecord, useStateManager, BCMSStateManagerCRUD } from "bcms-react";
import Classes, { CheckingAccount, StopPayment } from "model";

import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContentView, PageHeaderView, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView } from 'components/shared';
import PageContainer from 'components/shared/containers/PageContainer';
import { TableBody } from 'components/shared/views/TableView';
import { PrimaryButton } from 'components/ui';
import { AccountSelect } from '../StopPaymentPage';
import MobileStopPaymentView from './components/MobileStopPaymentView';
import Util from "classes/Util";
import "./mobile.css";
import "./styles.css";

/**
 * @function StopPaymentHistoryPage
 * @return {React.Component}
 * @exported true
 * @description The main component for StopPaymentHistoryPage
 */
export default function StopPaymentHistoryPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onClick: evt => {
            BCMSStateManagerCRUD.init(state)
                .update([ "ui", "showPayments" ], true)
                .submit(setState);
        }
    });

    return (
        <PageContainer className="stop-payment-history" state={ { data, ui } } controller={ controller }>
            <StopPaymentHistoryContent />
        </PageContainer>
    );
}

export const getDefaultPageData = () => ({});
export const getDefaultPageUI = () => ({
    showPayments: false
});

function StopPaymentHistoryContent(props) {
    const { onClick, ui } = useStateManager();

    const payments = StopPayment.initAll();
    const accounts = CheckingAccount.initAll();

    const desktopItems = payments.map(payment => {
    return <StopPaymentItem payment={ payment } key={ `desktop_${ payment.id }`} />
    }, []);
    const mobileItems = payments.map(payment => {
    return <MobileStopPaymentView key={ `mobile_${ payment.id }`} payment={ payment } />
    }, []);

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Stop Payment History" />
                <Link className="stop-payment-link" to="/stopPayment" dataPoint="Stop_Payment_History">Stop Payment</Link>
                {/* Account Dropdown and Search button are not shown in mabi23. */}
                { !Util.inMabi && 
                    <FormContainer className="stop-payments-history-form small-form-width">
                        <FormRowView text="Account:">
                            {/* AccountSelect */}
                            <AccountSelect accounts={accounts} dataPoint="Account_DD"/>
                        </FormRowView>
                        <FormRowView>
                            <PrimaryButton text="Search" onClick={onClick} data-point="Search"/>
                        </FormRowView>
                    </FormContainer>
                }
                {/* All "Stop Payments" are shown by default in mabi23. */}
                { (ui.showPayments || Util.inMabi) && 
                    <>
                    {
                        desktopItems.length > 0 &&
                        <div className="show-on-desktop">
                            <TableView className="stop-payment-history-table">
                                <TableColumnContainer className="text-left">
                                <TableColumnView text="Start Check"></TableColumnView>
                                <TableColumnView text="End Check"></TableColumnView>
                                <TableColumnView text="Amount"></TableColumnView>
                                <TableColumnView text="Effective"></TableColumnView>
                                <TableColumnView text="Payee"></TableColumnView>
                                <TableColumnView text="Reason"></TableColumnView>
                                <TableColumnView text="CheckDate"></TableColumnView>
                                </TableColumnContainer>

                                <TableBody>
                                    { desktopItems }
                                </TableBody>
                            </TableView>
                        </div>
                    }

                    { mobileItems }
                    </>
                }
            </CenterContentContainer>
        </PageContentView>
    )
}

/**
 * @function function StopPaymentItem(props){

 * @param {STRING} payment - Brings in the payment details  
 * @return {React.Component}
 * @exported true
 * @description The StopPaymentItem shows the payment details
 * @example
 * <StopPaymentItem payment={payment} />
 */

function StopPaymentItem(props){
    let payment = props.payment; 
    return(
      <TableItemContainer>
        <TableItemTextView text={payment.startCheck} dataPoint={`Start_Check_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.endCheck} dataPoint={`End_Check_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.amount.format()} dataPoint={`Amount_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.effective.format("m/d/Y")} dataPoint={`Effective_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.payee} dataPoint={`Payee_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.reason} dataPoint={`Reason_${payment.id}`}></TableItemTextView>
        <TableItemTextView text={payment.checkDate.format("m/d/Y")+" "+ payment.checkTime} dataPoint={`CheckDate_${payment.id}`}></TableItemTextView>
      </TableItemContainer>
    )
  } 